/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import sizes from './sizes';

/**
 * A placeholder for a bottle image
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.size] The image size.
 */
export default function BottleImagePlaceholder({
  className,
  size = 'large',
  ...rest
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // @ts-ignore
      sx={{
        width: sizes[size],
        height: sizes[size],
        verticalAlign: 'middle',
        color: 'brand.gray',
      }}
      width={sizes[size]}
      height={sizes[size]}
      className={className}
      viewBox="0 0 9 30"
      {...rest}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.75,8.30519922 L2.75,0.668478261 C2.75,0.299347826 3.09180851,0 3.51348404,0 L5.48707447,0 C5.90819149,0 6.25,0.299347826 6.25,0.668478261 L6.25,8.30506715 C7.86612838,8.89529116 9.0001415,10.2783399 9,11.8903804 L9,14.0520109 L9,20.8501087 L9,28.1192391 C9,28.857337 8.30804049,29.4560326 7.45426542,29.4560326 L1.54630037,29.4560326 C0.692525303,29.4560326 0,28.857337 0,28.1192391 L0,20.8501087 L0,14.0520109 L0,11.8903804 C0,10.2783586 1.13416841,8.89547212 2.75,8.30519922 Z"
      ></path>
    </svg>
  );
}
